import React from 'react';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type ChecklistGroup = {
  title: string;
  items: string[];
};

type Props = {
  groups: ChecklistGroup[];
};

/**
 * チェックリスト表示コンポーネント
 * グループごとにタイトル + チェック項目をボーダー付きボックスで表示する
 */
const WorkflowChecklist: React.FC<Props> = ({ groups }) => {
  return (
    <Stack spacing={2}>
      {groups.map((group) => (
        <Box
          key={group.title}
          sx={{
            border: 1,
            borderColor: 'divider',
            borderRadius: 2,
            p: 2,
          }}
        >
          <Typography variant="body2" fontWeight={600} sx={{ mb: 1.5 }}>
            {group.title}
          </Typography>
          <Stack spacing={0.75}>
            {group.items.map((item) => (
              <Stack key={item} direction="row" alignItems="flex-start" spacing={1}>
                <CheckBoxOutlineBlankIcon
                  sx={{ fontSize: 18, color: 'text.disabled', mt: 0.2, flexShrink: 0 }}
                />
                <Typography variant="body2" color="text.secondary">
                  {item}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Box>
      ))}
    </Stack>
  );
};

export default WorkflowChecklist;
